import { invoke } from '@shared/easyfy.decorators';
import { globalEvent } from '@shared/easyfy.core';
import { show, toggleShow } from '@shared/easyfy.utils';

namespace Easyfy.Modules {
  @invoke
  export class HeaderMenu {

    constructor() {

    }

    onInit() {

      globalEvent({
        type: 'click',
        event: {
          event: 'toggle-header-menu',
          callback: HeaderMenu.onToggleHeaderMenu
        }
      });

    }

    static onToggleHeaderMenu(e) {
      e.preventDefault();

      toggleShow('[data-container="header-dropdown"]', "grid")
    }

  }
}

export default Easyfy.Modules;